export enum REPORT_TYPES {
  EXCEL = 'EXCEL',
  PDF = 'PDF',
}
